export const patientRPMAction = {
  togglePatientRPMModal: (state, action) => {
    const { type, value } = action.payload;

    switch (type) {
      case "communicationLog": {
        const { open, action, data, copyOriginal = true } = value;

        state.isCommunicationLogModal = open;
        state.communicationLogAction = action;
        state.currentCommunicationLog = data;

        if (copyOriginal) {
          state.originalCommunicationLog = data;
        }
        break;
      }

      default:
    }
  },

  onCommunicationLogChange: (state, action) => {
    state.currentCommunicationLog = action.payload;
  },

  onRPMRowChange: (state, action) => {
    state.currentRpmRowData = action.payload;
  },

  toggleCommunicationLogCancelModal: (state, action) => {
    state.isCommunicationLogCancelModal = action.payload;
  },

  toggleCommunicationLogDeleteModal: (state, action) => {
    const { open, data } = action.payload;
    state.isCommunicationLogDeleteModal = open;
    state.deletingCommunicationId = data;
  },

  toggleFetchRPMPatientData: (state, action) => {
    state.fetchRPMPatientData = action.payload;
  },

  onBPReadingView: (state, action) => {
    state.bpReadingsList = action.payload;
  },

  storeScaleChartData: (state, action) => {
    state.scaleChartData = action.payload;
  },
};
